import { Image } from '@hivebrite/design-system/Image';

/**
  @deprecated
  - Use `import { Image } from '@hivebrite/design-system/Image';` instead
  - Use `size` prop instead of `imageSize`.
 */
export default Image;
